var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Label1, Label2, Label4 } from "@irati/ui/src/Labels";
import sessionService from "@irati/auth/services/login";
import FormattedMessage, { FormattedDate } from "@irati/utils/lang";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import { TextButton } from "@irati/ui/src/Button";
import Loading from "@irati/ui/src/Loading";
import { StyledCard, Flex, FlexLeft, FlexRight, CurrentSession } from "./styled";
var Security = /** @class */ (function (_super) {
    __extends(Security, _super);
    function Security() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {};
        _this.handleRemove = function () {
            var session = _this.props.session;
            _this.setState({ delete: sessionService.removeActiveSession(session.uuid) });
        };
        return _this;
    }
    Security.prototype.parseUserAgent = function (session) {
        try {
            var _a = JSON.parse(session.userAgent), browser = _a.browser, os = _a.os, ip = _a.ip;
            return { ip: ip, os: os, browser: browser };
        }
        catch (e) {
            return { ip: "unknown", browser: "unknown", os: "unknown" };
        }
    };
    Security.prototype.lastActive = function (session) {
        return session.refreshedAt || session.createdAt;
    };
    Security.prototype.render = function () {
        var session = this.props.session;
        var _a = this.parseUserAgent(session), ip = _a.ip, browser = _a.browser, os = _a.os;
        return (React.createElement(StyledCard, { tiny: true },
            session.isCurrent && (React.createElement(CurrentSession, null,
                React.createElement(FormattedMessage, { id: "account.security.sessions.current" }))),
            React.createElement(Flex, null,
                React.createElement(FlexLeft, null,
                    React.createElement(Label1, null, os),
                    React.createElement(Label2, null, browser),
                    React.createElement(Label4, null,
                        "ip: ",
                        ip),
                    React.createElement(Label4, null,
                        "Last Active: ",
                        React.createElement(FormattedDate, { value: this.lastActive(session) }))),
                React.createElement(FlexRight, null,
                    React.createElement(Loading, { load: this.state.delete },
                        React.createElement(TextButton, { onClick: this.handleRemove, marginRight: true },
                            React.createElement(Icon, { icon: IconTypes.bin })))))));
    };
    return Security;
}(PureComponent));
export default Security;
